import {showFromFade, loadLibrary} from "../../js/Util";
import { LIB_URL } from '../../js/App';

if ($(".js-calculate-form").length && window.calculatorData) {
    const calculatorData = window.calculatorData;

    let $rangeBudget = $(".js-range-slider-budget");
    let $rangeErrand = $(".js-range-slider-errand");

    let $valueBudget = $(".js-input-range-value-budget");
    let $valueErrand = $(".js-input-range-value-errand");

    loadLibrary(LIB_URL.ION_RANGE_SLIDER, () => {
        initRangeSlider(
            $rangeBudget,
            calculatorData.data.budgets,
            $valueBudget
        );
        initRangeSlider(
            $rangeErrand,
            calculatorData.data.quantity_trips,
            $valueErrand
        );
    });

    $(".js-btn-next-step").click(function (e) {
        e.preventDefault();

        let $activeItem = $(".calculate-form__item._active");

        $(".calculate-form__item").removeClass("_active");
        $activeItem.next().addClass("_active");

        changeStepsCalculateForm();
    });

    $(".js-btn-prev-step").click(function (e) {
        e.preventDefault();

        let $activeItem = $(".calculate-form__item._active");

        $(".calculate-form__item").removeClass("_active");
        $activeItem.prev().addClass("_active");

        changeStepsCalculateForm();
    });

    const $colWorkers = $("[name='col-personal']");
    const $method = $("[name='method']");

    checkboxChange($colWorkers);
    checkboxChange($method);

    const $btnSubmitFormCalculate = $(".js-btn-submit-form-calculate");

    $btnSubmitFormCalculate.click(function () {
        const $colWorkersChecked = $("[name='col-personal']:checked");
        const $methodChecked = $("[name='method']:checked");

        checkInputs($colWorkers, $colWorkersChecked);
        checkInputs($method, $methodChecked);

        if ($(".validate-message._active").length) {
            return false;
        }
        calculateResults(
            $valueBudget.data("value"),
            $valueErrand.data("value"),
            $colWorkersChecked.val(),
            $methodChecked.val()
        );
    });
}

function initRangeSlider(elemInit, elemValues, elemValueText) {
    elemInit.ionRangeSlider({
        grid: false,
        values: elemValues,
        min: elemValues[0],
        onStart: function (data) {
            if (data.from_value) {
                let valueRanks = data.from_value.toLocaleString();
                elemValueText
                    .text(valueRanks)
                    .attr("data-value", data.from_value);
            }
            elemInit.attr("data-min", elemValues[0]);
        },
        onChange: function (data) {
            if (data.from_value) {
                let valueRanks = data.from_value.toLocaleString();
                elemValueText
                    .text(valueRanks)
                    .attr("data-value", data.from_value);
            }
        },
        onUpdate: function (data) {
            if (data.from_value) {
                let valueRanks = data.from_value.toLocaleString();
                elemValueText
                    .text(valueRanks)
                    .attr("data-value", data.from_value);
            }
            elemInit.attr("data-min", elemValues[0]);
        },
    });
}

function checkboxChange(input) {
    input.on("change", function () {
        input
            .closest(".calculate-form__item")
            .find(".validate-message")
            .removeClass("_active");
    });
}
function checkInputs(input, inputChecked) {
    if (inputChecked.length > 0) {
        input
            .closest(".calculate-form__item")
            .find(".validate-message")
            .removeClass("_active");
    } else {
        input
            .closest(".calculate-form__item")
            .find(".validate-message")
            .addClass("_active");
    }
}

let firstStep2 = true;
function changeStepsCalculateForm() {
    let currentStep = Number(
        $(".calculate-form__item._active").attr("data-step")
    );

    if (currentStep === 2 && firstStep2) {
        let $rangeErrand = $(".js-range-slider-errand");
        $rangeErrand.data("ionRangeSlider").reset();
        firstStep2 = false;
    }

    if (currentStep !== 1) {
        $(".js-btn-prev-step").removeClass("_hidden");
    } else {
        $(".js-btn-prev-step").addClass("_hidden");
    }

    if (currentStep === $(".js-calculate-form__items>div").length) {
        $(".js-btn-next-step").addClass("_hidden");
        $(".js-btn-submit-form-calculate").addClass("_active");
    } else {
        $(".js-btn-next-step").removeClass("_hidden");
        $(".js-btn-submit-form-calculate").removeClass("_active");
    }
}

function calculateResults(budgets, quantity_trips, employees, types) {
    const $formleft = $(".js-calculate-form__left");
    const $formRight = $(".js-calculate-form__right");
    const $textRequest = $(".js-calculate-result--title");
    const $descRequest = $(".js-calculate-result--desc");
    const $imgRequest = $(".js-calculate-result--img img");
    const $btnCase = $(".js-btn--case");
    const $btnSubmitFormCalculate = $(".js-btn-submit-form-calculate");

    const calculationResultData =
        window.calculatorData.calculation[types]["" + budgets][
            "" + quantity_trips
        ];

    $textRequest.text(window.calculatorData.data.result_message
        .replace('%s', calculationResultData.savings)
        .replace('%s', calculationResultData.amount)
    );

    if (calculationResultData.case_description) {
        $descRequest.text(calculationResultData.case_description);
    }
    $imgRequest.attr("src", calculationResultData.case_img);
    $btnSubmitFormCalculate.addClass("_hidden");
    $btnCase.attr("href", calculationResultData.case_link);
    $btnCase.addClass("_active");

    // let $rangeBudget = $(".js-range-slider-budget");
    // let $rangeErrand = $(".js-range-slider-errand");
    // let $valueBudget = $(".js-input-range-value-budget");
    // let $valueErrand = $(".js-input-range-value-errand");

    // $rangeBudget.data("ionRangeSlider").reset();
    // $rangeErrand.data("ionRangeSlider").reset();
    // $valueBudget.text(
    //     Number($rangeBudget.attr("data-min")).toLocaleString()
    // );
    // $valueErrand.text($rangeErrand.attr("data-min"));

    if (App.W.width() < 1100) {
        $formleft.addClass("_hidden");
        $formRight.addClass("_active");
    }
}

if ($(".calculate-wrap").length) {
    $(".calculate-wrap")
        .each((index, item) => {
            const start =
                $(document).width() >= 768
                    ? "top bottom-=20%"
                    : "top bottom-=10%";
            showFromFade(item, start);
        });
}
